var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error-messages"}},[_c('span',[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }